import { Option } from '@sapphire/result';
import { match } from 'ts-pattern';

import { SURVEY_CLASSIFICATION_KIND } from '../constants/survey-classification.constants';
import { classifySurvey } from '../survey-classifier/survey-classifier';
import type { Survey } from '../models/survey.model';
import {
  resolveGroupedParent,
  resolveTrackerParent,
} from './survey-project-stats';

function firstSurveyId(
  surveys: ReadonlyArray<{ surveyId: number }>,
): Option<number> {
  return Option.from(surveys[0]).map((child) => child.surveyId);
}

export function resolveFirstProjectChildId(survey: Survey): Option<number> {
  return match(classifySurvey(survey).kind)
    .with(SURVEY_CLASSIFICATION_KIND.GROUP_MC, () =>
      Option.from(survey.mc).mapInto((mc) => firstSurveyId(mc.surveys)),
    )
    .with(SURVEY_CLASSIFICATION_KIND.TRACKER, () =>
      Option.from(resolveTrackerParent(survey)).mapInto((stats) =>
        firstSurveyId(stats.surveys),
      ),
    )
    .with(SURVEY_CLASSIFICATION_KIND.GROUPED, () =>
      Option.from(resolveGroupedParent(survey)).mapInto((stats) =>
        firstSurveyId(stats.surveys),
      ),
    )
    .otherwise(() => Option.none);
}
